module.exports = __webpack_public_path__ + "static/media/plans.8e736b54.svg";